import FAQArticlePage from "./FAQArticle";

const data = {
  title: "I was unaware of the charges",
  category: "Billing & Payments",
  content: `We understand that discovering unexpected charges can be frustrating. If you were unaware of charges on your account, here's how we can help.

Common reasons for unaware charges:
- Free trial that converted to a paid subscription after the trial period
- Subscription renewal that was forgotten about
- A family member used your payment method
- The charge appears under a different company name (Nova Vertex LTD)

What we can do:
- Provide a full transaction history for your account
- Explain when and how the subscription was started
- Process a refund if the charge was made in error or without your knowledge
- Cancel any active subscriptions to prevent future charges

How to prevent future unaware charges:
- Keep track of your subscription renewal dates
- Read the terms carefully when signing up for free trials
- Use our support team to cancel subscriptions you no longer need

To request a refund or discuss these charges:
- Contact our support team directly, or
- Submit a dispute form through our Help Center

We are committed to fair billing practices and will work with you to resolve any billing concerns.

Email: support@novavertextech.com
Phone: +44 7520 663474`,
};

export default function BPQ3Page() {
  return <FAQArticlePage data={data} />;
}